import {SOPutRelationshipAttributePermission} from '../../core/relationship-attribute-permission/so-put-relationship-attribute-permission';
import {RelationshipAttributePermissionCore} from './relationship-attribute-permission.core';
import {SOGetRelationshipAttributePermission} from '../../core/relationship-attribute-permission/so-get-relationship-attribute-permission';
import {FormField, SelectionOption} from 'lionheartland';
import {putRelationshipAttributePermissionFormFieldOptions} from './put-relationship-attribute-permission-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {RelationshipAttributeCore} from '../relationship-attribute/relationship-attribute.core';
import {SOGetRelationshipAttribute} from '../../core/relationship-attribute/so-get-relationship-attribute';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutRelationshipAttributePermission extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putRelationshipAttributePermissionFormFieldOptions);

  RequestClass = SOPutRelationshipAttributePermission

  constructor(
    public entityCore: RelationshipAttributePermissionCore
  ) {
    super();
    if (putRelationshipAttributePermissionFormFieldOptions.relationshipAttribute) {
      putRelationshipAttributePermissionFormFieldOptions.relationshipAttribute.makeCore = true;
    }
    if (putRelationshipAttributePermissionFormFieldOptions.project) {
      putRelationshipAttributePermissionFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('whiteList'),
      this.getFormValueFromIdentifier('permissionType'),
      this.getFormValueFromIdentifier(
        'relationshipAttribute',
        SOGetRelationshipAttribute,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}